<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">{{$t('driver')}}: {{data ? data.name : null}}</h4>
                    <p class="text-subtitle-1">{{$t('driver_information')}}</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3" v-if="hasPermission(permissions.driver.update)">
                    <v-btn depressed block @click="handleEdit">
                        <v-icon left>mdi-pencil</v-icon>
                        {{$t('edit')}}
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(permissions.driver.delete)">
                    <v-btn
                        block
                        color="error--text"
                        depressed
                        @click="handleDelete"
                        :loading="deleteLoading"
                    >
                        <v-icon left>
                            mdi-delete
                        </v-icon>
                        {{$t('delete')}}
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>{{$t('name')}}</th>
                                <td>{{ data ? data.name : null }}</td>
                            </tr>
                            <tr>
                                <th>{{$t('phone')}}</th>
                                <td>{{ data ? data.phone : null }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>{{$t('created_by')}}</th>
                                <td>{{ data && data.created_by ? `${data.created_by.first_name} ${data.created_by.last_name}` : null }}</td>
                            </tr>
                            <tr>
                                <th>{{$t('created_at')}}</th>
                                <td>{{ data ? data.created_at : null }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" md="6">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>{{$t('updated_by')}}</th>
                                <td>{{ data && data.updated_by ? `${data.updated_by.first_name} ${data.updated_by.last_name}` : null }}</td>
                            </tr>
                            <tr>
                                <th>{{$t('updated_at')}}</th>
                                <td>{{ data ? data.updated_at : null }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex flex-row">
                    <v-skeleton-loader type="button" class="my-2 mx-2"/>
                    <v-skeleton-loader type="button" class="my-2 mx-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.model" v-bind="alert"/>
    </v-container>
</template>

<script>
import driverAPI from './../../services/fleet/driver';
import permissions from '../../data/permissions';
import authorize from '../../utils/authorize';
export default {
    data() {
        return {
            data: null,
            driverID: null,
            loading: false,
            deleteLoading: false,
            alert: {
                title: "Alert",
                content: "",
                callback: null,
                model: false
            },
            permissions
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        fetchDriverAsync() {
            this.loading = true;
            driverAPI.get(this.driverID).then(response => {
                this.data = response.data;
            }).finally(() => {
                this.loading = false;
            })
        },
        handleEdit() {
            this.$router.push({ name: "DriverEdit"})
        },
        handleDelete() {
            this.alert = {...this.alert, model: true, content: "Are you sure you want to delete?", callback: this.remove}
        },
        remove() {
            this.deleteLoading = true;    
            driverAPI.remove(this.driverID).then(() => {
                this.$router.replace({ name: "DriversList" });
            }).finally(() => {
                this.deleteLoading = false;
            })
        }
    },
    created() {
        this.driverID = this.$route.params.driverID;
        this.fetchDriverAsync();
    }
}
</script>

<style>

</style>